<template>
  <b-card>

<!--    <b-container fluid class="p-4 bg-dark">-->
<!--      <table id="Table_01" width="800" height="531"  border="0" cellpadding="0" cellspacing="0" align="center" >-->
<!--        <tr>-->
<!--          <td>-->
<!--            <img src="images/800_01.gif" width="202" height="110" alt=""></td>-->
<!--          <td>-->
<!--            <img src="images/800_02.gif" width="366" height="110" alt=""></td>-->
<!--          <td>-->
<!--            <img src="images/800_03.gif" width="232" height="110" alt=""></td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td>-->
<!--            <img src="images/800_04.gif" width="202" height="231" alt=""></td>-->
<!--          <td>-->
<!--            <img src="images/800_05.gif" width="366" height="231" alt=""></td>-->
<!--          <td>-->
<!--            <img src="images/800_06.gif" width="232" height="231" alt=""></td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td>-->
<!--            <a href="#/login?th=1">-->
<!--            <img src="images/800_07.gif" width="202" height="190" alt=""></a>-->
<!--          </td>-->

<!--          <td>-->
<!--            <a href="#/login?th=0">-->
<!--              <img src="images/800_08.gif" width="366" height="190" alt=""></a>-->
<!--          </td>-->

<!--          <td>-->

<!--            <img src="images/800_07.gif" width="202" height="190" alt="">-->
<!--          </td>-->
<!--          <td>-->
<!--              <img src="images/800_08.gif" width="366" height="190" alt="">-->
<!--          </td>-->
<!--          <td>-->
<!--            <img src="images/800_09.gif" width="232" height="190" alt=""></td>-->
<!--        </tr>-->
<!--      </table>-->

<!--      <table id="Table_01" width="800" height="532" border="0" cellpadding="0" cellspacing="0" align="center"  >-->
<!--        <tr>-->
<!--          <td>-->
<!--            <img src="images/7_01.gif" width="200" height="266" alt=""></td>-->
<!--          <td>-->
<!--            <img src="images/7_02.gif" width="200" height="266" alt=""></td>-->
<!--          <td>-->
<!--            <img src="images/7_03.gif" width="400" height="266" alt=""></td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td>-->
<!--            <img src="images/7_04.gif" width="200" height="186" alt=""></td>-->
<!--          <td>-->
<!--            <img src="images/7_05.gif" width="200" height="186" alt=""></td>-->
<!--          <td>-->
<!--            <img src="images/7_06.gif" width="400" height="186" alt=""></td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td>-->
<!--          <a href="#/login?th=1">-->
<!--            <img src="images/7_07.gif" width="200" height="80" alt="Login TH"></a>-->
<!--          </td>-->
<!--          <td>-->
<!--          <a href="#/login?th=0">-->
<!--            <img src="images/7_08.gif" width="200" height="80" alt="Login EN">-->
<!--          </a>-->
<!--          </td>-->
<!--          <td>-->
<!--            <img src="images/7_09.gif" width="400" height="80" alt=""></td>-->
<!--        </tr>-->
<!--      </table>-->
<!--                </b-container>-->
    ปิดการทดสอบ
              </b-card>
            </template>

            <script>

            export default {
              components: {},
              name: "CreateIndex",
              data() {
                return {};
              },
              methods: {},
              mounted() {
              },
              created() {
                // window.location.href = "http://ccr.mfu.ac.th/graduateceremony/#/index";
                // if (this.$store.state.token == null || this.$store.state.user == null) {
                //   this.$router.push("/Login");
                // }
                // this.std_id = this.$store.state.user.studentid;
                // this.thai_student = this.$store.state.user.thaistudent;
                // this.levelid = this.$store.state.user.levelid;
                // this.actionUpdate = this.getCurrentStudent(this.std_id, this.thai_student);
              }
            };
            </script>
            <style>
            /* ใช้ได้เฉพาะกับ ID "page-specific" */
            #page-specific img {
              width: 50%;
              height: auto;
              display: block;
            }

            @media (min-width: 1024px) {
              #page-specific img {
                width: auto; /* ขนาดเท่ากับรูปต้นฉบับ */
                height: auto;
                max-width: none; /* ยกเลิกการบังคับความกว้าง */
              }
            }
            /*table {*/
            /*  width: 50%;*/
            /*  border-collapse: collapse;*/
            /*}*/
            /*img {*/
            /*  width: 100%;*/
            /*  height: auto;*/
            /*  display: block;*/
            /*}*/
            /*td {*/
            /*  padding: 0;*/
            /*}*/
            /*@media (max-width: 768px) {*/
            /*  table {*/
            /*    display: block;*/
            /*    overflow-x: auto;*/
            /*  }*/
            /*  tr {*/
            /*    display: flex;*/
            /*    flex-direction: column;*/
            /*  }*/
            /*  td {*/
            /*    width: 100%;*/
            /*  }*/
            /*}*/


            </style>
